module.exports = __webpack_public_path__ + "static/two-zero-hunger.088634c8.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/two-zero-hunger.webp
// module id = 921
// module chunks = 3